import { AbstractStorageModule } from "@/services/storage/AbstractStorageModule";
import { Page } from '@/services/storage/shopify/Page';
import { Shop } from '@/services/storage/shopify/Shop';
import { Customer } from '@/services/storage/shopify/Customer';
import { Order } from '@/services/storage/shopify/Order';
import { Cart } from "@/services/storage/shopify/Cart";
import {Product} from "@/services/storage/shopify/Product";

export class Shopify extends AbstractStorageModule {
    page = new Page();
    shop = new Shop();
    customer = new Customer();
    order = new Order();
    cart = new Cart();
    product = new Product();

    modules = ['page', 'shop', 'customer', 'order', 'cart', 'product'];

    resolve() {
        this.modules.forEach(module => {
            if(module in this) this[module].resolve();
        });
    }
}
